import { Component, OnInit } from '@angular/core';
import { BackOffServiceService } from '../services/back-off-service.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserData } from '../model/UserData';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
// import { MatButtonModule } from '@angular/material';

@Component({
  selector: 'app-register-component',
  templateUrl: './register-component.component.html',
  styleUrls: ['./register-component.component.css']
})
export class RegisterComponent implements OnInit {

  registerationForm: FormGroup;
  submitted: boolean = false;

  successMessage: string;
  failedMessage: string;
  isLoggin: boolean = false;

  constructor(
    private _bkoffService: BackOffServiceService,
    private formBuilder: FormBuilder,
    private router: Router,
    private cookie: CookieService,
    private modalService: NgbModal
  ) {

  }

  ngOnInit() {
    this._bkoffService.getAccessRegexPattern().then((res) => {
      let regexPatterns = {
        // this can be improved
        codes: res.toString()
      };
      this.registerationForm = this.formBuilder.group({
        fullName: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required, Validators.minLength(7)]],
        accesCode: ['', [Validators.required, Validators.pattern(regexPatterns.codes)]]
      });
    })
  }

  get fmBuilder() { return this.registerationForm.controls; }


  getFormControl(name: any) {
    return this.registerationForm.get(name);
  }


  reset() {
    this.registerationForm.reset({ PersonalData: new UserData() });
  }

  signUpSubmit() {
    //delete when parse working
    // Make sure to create a deep copy of the form-model
    const result: UserData = Object.assign({}, this.registerationForm.value);
    let fromResult = Object.assign({}, result);


    this.submitted = true;

    console.log("about to check form validation");

    const signUpData = this.registerationForm;
    var signUpSucceeded = false;

    var userInfo = new UserData()
    userInfo.Email = signUpData.get(['email']).value
    userInfo.password = signUpData.get(['password']).value
    userInfo.access = signUpData.get(['accesCode']).value
    userInfo.FullName = signUpData.get(['fullName']).value

    var isDone = new UserData()
    isDone.isLifestyleDone = false;
    isDone.isAdmin = false;
    isDone.isFirstCheckList = true;
    isDone.isCoach = false;

    this._bkoffService.getAccessCode().then((res) => {
      res.forEach(element => {
        if (signUpData.get(['accesCode']).value == element){
          signUpSucceeded = true; 
        }
      });
      if (signUpSucceeded){
        console.log("Signup was successful!");
      }else{
        console.log("Signup was unsuccessful!\nThe access code didn't match.");
      }
      if (signUpSucceeded === false){
        this.fmBuilder.accesCode.errors.required = true
        return
      }

      this._bkoffService.createProgramGoals().then((res) => {
        console.log("successfully created program goals ");
        userInfo.progGoalId = res.id;
        this.cookie.set("userProgGoalId", res.id);
        this._bkoffService.signUp(userInfo).then((user) => {
          this.cookie.set("userObjectId", user.id);
          this.cookie.set("sessionToken", user.getSessionToken());
          this.cookie.set("isRegistering", "true");
          this.successMessage = "Successfully created account !"
          this._bkoffService.LoggedIn = true;
          console.log("successfully created account ")
          this._bkoffService.setProgGoalUserId(user.id);
          this.router.navigateByUrl('/quiz1');
          // this._bkoffService.setActivityPlan(isDone);
          this._bkoffService.setupIsDone();
        })
      }).catch(() => {
        this.failedMessage = "Error creating program goals"
        console.log(this.failedMessage)
      });
  
      this._bkoffService.createRiskQuiz().then((rquiz) => {
        this.cookie.set("riskQuizObjectId", rquiz.id);
        console.log("successfully created riskQuiz ")
      }).catch(() => {
        this.failedMessage = "Error creating risk quiz"
        console.log(this.failedMessage)
      });
  
      this._bkoffService.createMotivationQuiz().then((mquiz) => {
        this.cookie.set("motivQuizObjectId", mquiz.id);
        console.log("successfully created motivQuiz ")
      }).catch(() => {
        this.failedMessage = "Error creating motiv quiz"
        console.log(this.failedMessage)
      });
  
      this._bkoffService.createDemoQuiz().then((dquiz) => {
        this.cookie.set("demoQuizObjectId", dquiz.id);
        console.log("successfully created demoQuiz ")
      }).catch(() => {
        this.failedMessage = "Error creating demography quiz"
        console.log(this.failedMessage)
      });
  
      this._bkoffService.createSdohQuiz().then((squiz) => {
        this.cookie.set("sdohQuizObjectId", squiz.id);
        console.log("successfully created sdohQuiz ")
      }).catch(() => {
        this.failedMessage = "Error creating SDOH quiz"
        console.log(this.failedMessage)
      });

      this._bkoffService.createComorbidityQuiz().then((cquiz) => {
        this.cookie.set("comorbidityQuizObjectId", cquiz.id);
        console.log("successfully created comorbidityQuiz ")
      }).catch(() => {
        this.failedMessage = "Error creating Comorbidity quiz"
        console.log(this.failedMessage)
      });

      this._bkoffService.createPreferenceQuiz().then((pquiz) => {
        this.cookie.set("preferenceQuizObjectId", pquiz.id);
        console.log("successfully created preferenceQuiz")
      }).catch(() => {
        this.failedMessage = "Error creating Preference quiz"
        console.log(this.failedMessage)
      });
    });
  }

  toggleSignup(){
    this.isLoggin = !this.isLoggin
  }
 
}
